export const TOTAL_CREDITS = {
  prefix: "$",
  value: 1664645.7972,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
